// src/components/strumenti/ConversioneBtuW.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };
const BTU_PER_W = 3.412142;

export default function ConversioneBtuW() {
  const [modo, setModo] = useState("btu_w");
  const [valore, setValore] = useState("");

  const v = leggiNumero(valore)||0;
  const risultato = modo==="btu_w" ? v/BTU_PER_W : v*BTU_PER_W;

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("btu_w");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="btu_w"?"#0891b2":"#e5e7eb"}`, background: modo==="btu_w"?"#ecfeff":"#fff", color: modo==="btu_w"?"#0891b2":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>BTU/h → W</button>
        <button onClick={()=>{setModo("w_btu");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="w_btu"?"#0891b2":"#e5e7eb"}`, background: modo==="w_btu"?"#ecfeff":"#fff", color: modo==="w_btu"?"#0891b2":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>W → BTU/h</button>
      </div>

      <div style={{ marginBottom:16 }}>
        <label style={lbl}>{modo==="btu_w" ? "Potenza (BTU/h)" : "Potenza (W)"}</label>
        <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder={modo==="btu_w"?"Es. 9000":"Es. 2600"}/>
      </div>

      <div style={{ background:"#ecfeff", border:"1px solid #a5f3fc", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Risultato</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#0891b2" }}>
          {isNaN(risultato) ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:0})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="btu_w" ? "W" : "BTU/h"}</span>
        </div>
      </div>

      <button onClick={()=>setValore("")}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
